import { render, staticRenderFns } from "./VideoCallDetails.vue?vue&type=template&id=c04ff25a&"
import script from "./VideoCallDetails.vue?vue&type=script&lang=js&"
export * from "./VideoCallDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports